module.exports = __webpack_public_path__ + "static/media/ic-clock-nobg.7001220d.svg";